// extracted by mini-css-extract-plugin
export default {"bottomAd_box":"index_bottomAd_box_JnZXF","bottomAd":"index_bottomAd_7WzJ4"};